import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';

import { Button } from '../../components/Button';
import styled from 'styled-components';
import { Icon } from '../../components/Icon';
import { Error } from '../../components/Error';

import { selectErrors } from '../../modules/global/selectors';
import { fetchCustomerData, updateCustomer } from '../../modules/customer/actions';
import { selectIsFetching, selectCustomerData, selectUpdateCustomerFinished } from '../../modules/customer/selectors';
import { isValidEmail } from '../../utils/validator'
import { useValidation } from '../../utils/useValidation';
import { OfferingType } from '../../utils/offeringType';
import {useHistory} from "react-router-dom";

interface Props {
	errors: [];
	updateCustomer: (data: any) => void;
	data: any;
	isFetching: boolean;
	resetOnMount: () => void;
	updateCustomerFinished: boolean;
	offeringType: OfferingType;
}

const Container = styled.div`
	max-width: 26rem;
	text-align: center;
	margin: auto;
`;

const PageHead = styled.h4`
	font-size: 3.5rem;
	text-align: center;
	margin-top: 6rem;
`;

const ErrorMessage = styled.p`
	font-size: 1rem;
	color: red;
`;

const Center = styled.div`
	margin: auto;
	text-align: center;
`;

const InfoText = styled.p`
	float: left;
`;

export const EditBillingEmailPage: React.FC<Props> = (props: Props) => {
	const history = useHistory();
	const [email, setEmail] = useState('');
	const emailValidation = useValidation(email, isValidEmail);
	const [formSubmitted, setFormSubmitted] = useState(false);
	const handleSubmit = () => {
		if (emailValidation.isValid) {
			props.updateCustomer({
				updates: [
					{
						field: 'billing-email', value: email,
					},
				],
			});
			setFormSubmitted(true);
		} else {
			alert('tarkista kentät')
		}
	};
	const { data, isFetching, updateCustomerFinished, errors } = props;
	const ready = !isFetching && data !== null;
	const noErrors = errors && errors.length < 1;
	return (
		<article>
			<Helmet
				title="Muokkaa laskutusosoitetta"
				meta={[
					{ name: 'description', content: '' },
				]}
			/>
			{!formSubmitted && <PageHead>Laskutusosoite</PageHead>}
			{noErrors && ready && !formSubmitted &&
				<Container>
					<InfoText>Sähköpostiosoite jonne haluat laskun</InfoText>
					<input type="text" value={email} onChange={(e: any) => setEmail(e.target.value)} placeholder={data.toJS().email} />
					<ErrorMessage>
						{emailValidation.showError &&
							<span>Sähköpostiosoite ei ole kelvollinen.</span>
						}
					</ErrorMessage>
					<Button onClick={handleSubmit}>Tallenna</Button>
					<Button onClick={() => history.replace('/account/customerInfo')}>Peruuta</Button>
				</Container>
			}
			{noErrors && formSubmitted && updateCustomerFinished && (
				<Center>
					<h4>Sähköpostiosoite päivitetty onnistuneesti!</h4>
					<Icon name="medium--ok" />
				</Center>
			)}
			{!noErrors && (
				<Error message={'Jotain meni vikaan. Yritä myöhemmin uudestaan tai ota yhteyttä asiakaspalveluumme'} />
			)}
		</article>
	);
};

const mapStateToProps = (state: any) => ({
	errors: selectErrors(state),
	isFetching: selectIsFetching(state),
	data: selectCustomerData(state),
	updateCustomerFinished: selectUpdateCustomerFinished(state),
});

const mapDispatchToProps = (dispatch: any) => ({
	fetchCustomer: () => dispatch(fetchCustomerData()),
	updateCustomer: (data: any) => dispatch(updateCustomer(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditBillingEmailPage)
